// extracted by mini-css-extract-plugin
export default {"rating":"FP-z","numberOfStars":"GP-z","count":"HP-z","barGraphSpacing":"IP-z","barGraph":"JP-z"};